import { TYPES } from '../actions/types';

const initialState = {
  commits: [],
  commit: null,
  loading: true,
  error: null
};

export const commitReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case TYPES.ACTION_GET_COMMITS_SUCCESS:
      return {
        ...state,
        commits: payload,
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_COMMITS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };
    case TYPES.ACTION_GET_COMMIT_SUCCESS:
      return {
        ...state,
        commit: payload,
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_COMMIT_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };
    case TYPES.ACTION_UPDATE_COMMIT_SUCCESS:
      return {
        ...state,
        commits: state.commits.map(commit =>
          commit._id === payload._id ? payload : commit
        ),
        commit: payload,
        loading: false,
        error: null
      };
    case TYPES.ACTION_UPDATE_COMMIT_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };
    default:
      return state;
  }
} 